import { maxWidth, width } from "@mui/system"

export const asset_overview_columns = [
  {
    id: 'vehicleName',
    label: 'Vehicle',
    minWidth: 160
  },
  {
    id: 'sensors',
    label: 'Sensor(s)',
    minWidth: 180,
    isSortable: false
  },
  {
    id: 'trackers',
    label: 'Tracker(s)',
    minWidth: 180,
  },
  {
    id: 'controls',
    label: 'Controller(s)',
    minWidth: 180,
  },
]

export const asset_details_columns = [
  {
    id: 'type',
    label: 'Type',
    isSmallColumn: true,
    width: 138
  },
  {
    id: 'batteryLevel',
    label: 'Battery Level',
    width: 180,
    icon: true,           
    iconPosition: 'after',
    isSmallColumn: true,
  },
  {
    id: 'serialNumber',
    label: 'Serial number',
    width: 180,
  },
  {
    id: 'installedAt',
    label: 'Installed At',
    width: 160

  },
]





